import { ChefHat } from "lucide-react";

const Footer = () => {
  return (
    <footer className="border-t bg-background">
      <div className="container py-8 lg:py-12">
        <div className="grid gap-8 lg:grid-cols-2">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <ChefHat className="h-6 w-6 text-primary" />
              <span className="font-bold text-lg">30 Receitas Express</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Variedade real para seus almoços, com ingredientes simples e receitas rápidas.
            </p>
          </div>

          <div>
            <h3 className="font-bold mb-4">Informações</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="/politica-privacidade" className="hover:text-primary transition-colors">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href="/termos-uso" className="hover:text-primary transition-colors">
                  Termos de Uso
                </a>
              </li>
              <li>
                <a href="/politica-reembolso" className="hover:text-primary transition-colors">
                  Política de Reembolso
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} 30 Receitas Express. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
